import { withStyles } from "@material-ui/core"

import { ResponsiveLine } from "@nivo/line"
import React, { useEffect, useState } from "react"
import { useMediaQuery } from "react-responsive"
import WidgetCommon from "../Common/widgetCommon"

const styles = () => ({})

const InsightsLast2Weeks = (props) => {
  const {
    isLoading,
    insights,
    allowEdits,
    handleWidgetChange,
    widgetId,
    gridStep,
    position,
    size,
    handleRemove,
  } = props
  const [graphData, setGraphData] = useState([])

  const isMobile = useMediaQuery({ query: "(max-width: 625px)" })

  useEffect(() => {
    if (insights) {
      const dataMap = {}
      const currentDate = Date.now() + new Date().getTimezoneOffset() * 60 * 1000
      for (let i = 0; i < 14; i++) {
        const dateString = new Date(currentDate - (13 - i) * 24 * 60 * 60 * 1000)
          .toISOString()
          .split("T")[0]
        dataMap[dateString] = {
          index: i,
          x: dateString,
          y: 0,
        }
      }

      for (const insight of insights) {
        if (insight.time_stamp) {
          const insightDate = new Date(insight.time_stamp)
          if (insightDate.toISOString().split("T")[0] in dataMap) {
            dataMap[insightDate.toISOString().split("T")[0]].y += 1
          }
        }
      }
      setGraphData([{ id: "data", data: Object.values(dataMap).sort((a, b) => a.index - b.index) }])
    }
  }, [insights])

  return (
    <WidgetCommon
      widgetId={widgetId}
      title="Insights over the Last 2 Weeks"
      isLoading={isLoading}
      hasNoData={graphData.filter((data) => data.y !== 0).length === 0}
      hasTooMuchData={false}
      tooMuchDataString=""
      info="Information only shows the last 2 weeks, regardless of the filters."
      size={size}
      position={position}
      allowResize={true}
      allowEdits={allowEdits}
      handleWidgetChange={handleWidgetChange}
      gridStep={gridStep}
      handleRemove={handleRemove}
    >
      <div style={{ position: "absolute", width: "100%", height: "100%" }}>
        <ResponsiveLine
          data={graphData}
          margin={{ top: isMobile ? 10 : 50, right: 10, bottom: 90, left: isMobile ? 40 : 60 }}
          xScale={{ type: "point" }}
          yScale={{
            type: "linear",
            min: 0,
            max: "auto",
            reverse: false,
          }}
          yFormat=" >-.0f"
          colors={{ scheme: "paired" }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 90,
            legend: !isMobile && "Date",
            legendPosition: "middle",
            legendOffset: 80,
            truncateTickAt: 0,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: !isMobile && "Count",
            legendPosition: "middle",
            legendOffset: -40,
            truncateTickAt: 0,
          }}
          pointSize={10}
          pointColor={{ theme: "background" }}
          pointBorderWidth={2}
          pointBorderColor={{ from: "serieColor" }}
          pointLabelYOffset={-12}
          useMesh={true}
          ariaLabel="Insights in Last Month"
        />
      </div>
    </WidgetCommon>
  )
}

export default withStyles(styles)(InsightsLast2Weeks)
